import jsPDF from 'jspdf';
import 'jspdf-autotable';

/**
 * Export document summary to PDF
 */
export const exportDocumentToPDF = (document) => {
  const pdf = new jsPDF();
  
  // Title
  pdf.setFontSize(20);
  pdf.setTextColor(79, 70, 229); // Indigo
  pdf.text('OmniClarix', 20, 20);
  
  // Document Title
  pdf.setFontSize(16);
  pdf.setTextColor(0, 0, 0);
  pdf.text(document.file_name, 20, 35);
  
  // Date
  pdf.setFontSize(10);
  pdf.setTextColor(128, 128, 128);
  const date = new Date(document.created_at).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  pdf.text(date, 20, 45);
  
  let yPosition = 60;
  
  // Summary Section
  if (document.summary) {
    pdf.setFontSize(14);
    pdf.setTextColor(79, 70, 229);
    pdf.text('Summary', 20, yPosition);
    yPosition += 10;
    
    pdf.setFontSize(11);
    pdf.setTextColor(0, 0, 0);
    const summaryLines = pdf.splitTextToSize(document.summary, 170);
    pdf.text(summaryLines, 20, yPosition);
    yPosition += (summaryLines.length * 7) + 15;
  }
  
  // Keywords Section
  if (document.keywords && document.keywords.length > 0) {
    pdf.setFontSize(14);
    pdf.setTextColor(79, 70, 229);
    pdf.text('Keywords', 20, yPosition);
    yPosition += 10;
    
    pdf.setFontSize(11);
    pdf.setTextColor(0, 0, 0);
    const keywordsText = document.keywords.join(', ');
    const keywordsLines = pdf.splitTextToSize(keywordsText, 170);
    pdf.text(keywordsLines, 20, yPosition);
    yPosition += (keywordsLines.length * 7) + 15;
  }
  
  // Definitions Section
  if (document.definitions && Object.keys(document.definitions).length > 0) {
    // Check if we need a new page
    if (yPosition > 250) {
      pdf.addPage();
      yPosition = 20;
    }
    
    pdf.setFontSize(14);
    pdf.setTextColor(79, 70, 229);
    pdf.text('Definitions', 20, yPosition);
    yPosition += 10;
    
    pdf.setFontSize(11);
    
    Object.entries(document.definitions).forEach(([term, definition]) => {
      // Check if we need a new page
      if (yPosition > 270) {
        pdf.addPage();
        yPosition = 20;
      }
      
      // Term
      pdf.setTextColor(0, 0, 0);
      pdf.setFont(undefined, 'bold');
      pdf.text(`• ${term}`, 20, yPosition);
      yPosition += 7;
      
      // Definition
      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(64, 64, 64);
      const defLines = pdf.splitTextToSize(definition, 165);
      pdf.text(defLines, 25, yPosition);
      yPosition += (defLines.length * 7) + 5;
    });
  }
  
  // Footer
  const pageCount = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(128, 128, 128);
    pdf.text(`Generated by OmniClarix | Page ${i} of ${pageCount}`, 20, 285);
  }
  
  // Save PDF
  const fileName = `${document.file_name.replace(/\.[^/.]+$/, '')}_summary.pdf`;
  pdf.save(fileName);
};

/**
 * Export quiz to PDF
 */
export const exportQuizToPDF = (document, questions) => {
  const pdf = new jsPDF();
  
  // Title
  pdf.setFontSize(20);
  pdf.setTextColor(79, 70, 229);
  pdf.text('OmniClarix Quiz', 20, 20);
  
  // Document Title
  pdf.setFontSize(14);
  pdf.setTextColor(0, 0, 0);
  pdf.text(document.file_name, 20, 35);
  
  let yPosition = 50;
  
  questions.forEach((q, index) => {
    // Check if we need a new page
    if (yPosition > 250) {
      pdf.addPage();
      yPosition = 20;
    }
    
    // Question
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont(undefined, 'bold');
    const questionText = `${index + 1}. ${q.question}`;
    const questionLines = pdf.splitTextToSize(questionText, 170);
    pdf.text(questionLines, 20, yPosition);
    yPosition += (questionLines.length * 7) + 5;
    
    // Options
    pdf.setFont(undefined, 'normal');
    pdf.setFontSize(11);
    q.options.forEach((option, optIndex) => {
      const optionLetter = String.fromCharCode(65 + optIndex); // A, B, C, D
      const optionText = `${optionLetter}. ${option}`;
      const optionLines = pdf.splitTextToSize(optionText, 165);
      pdf.text(optionLines, 25, yPosition);
      yPosition += (optionLines.length * 6) + 3;
    });
    
    yPosition += 10;
  });
  
  // Answer key on new page
  pdf.addPage();
  pdf.setFontSize(16);
  pdf.setTextColor(79, 70, 229);
  pdf.text('Answer Key', 20, 20);
  
  yPosition = 35;
  pdf.setFontSize(11);
  pdf.setTextColor(0, 0, 0);
  
  questions.forEach((q, index) => {
    const correctLetter = String.fromCharCode(65 + q.correctAnswer);
    pdf.text(`${index + 1}. ${correctLetter}`, 20, yPosition);
    yPosition += 8;
  });
  
  // Save PDF
  const fileName = `${document.file_name.replace(/\.[^/.]+$/, '')}_quiz.pdf`;
  pdf.save(fileName);
};

const pdfExport = {
  exportDocumentToPDF,
  exportQuizToPDF,
};

export default pdfExport;